import { render, staticRenderFns } from "./PdfIndex.vue?vue&type=template&id=15355cd4&scoped=true"
import script from "./PdfIndex.vue?vue&type=script&lang=js"
export * from "./PdfIndex.vue?vue&type=script&lang=js"
import style0 from "./PdfIndex.vue?vue&type=style&index=0&id=15355cd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15355cd4",
  null
  
)

export default component.exports